import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5263efba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-viewer-toolbar level has-background-contents" }
const _hoisted_2 = { class: "image-viewer-toolbar-help level" }
const _hoisted_3 = { class: "image-viewer-toolbar-div-main level" }
const _hoisted_4 = { class: "image-viewer-toolbar-div level" }
const _hoisted_5 = { class: "frame-number-name" }
const _hoisted_6 = { class: "image-viewer-toolbar-frame-index-count" }
const _hoisted_7 = { class: "image-viewer-toolbar-div level" }
const _hoisted_8 = { class: "image-viewer-toolbar-div level" }
const _hoisted_9 = { class: "image-viewer-toolbar-div level" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_11 = { class: "image-viewer-toolbar-floating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BookMarkButton = _resolveComponent("BookMarkButton")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_InputSpinnerScale = _resolveComponent("InputSpinnerScale")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isKn)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'Help' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DssIcon, {
                icon: "circle-questionmark",
                label: _ctx.$t('header.help'),
                class: "has-form-label"
              }, null, 8, ["label"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isKn && !_ctx.isRekion)
          ? (_openBlock(), _createBlock(_component_BookMarkButton, {
              key: 0,
              pid: _ctx.bookmarkSt.pid,
              bid: _ctx.bookmarkSt.bid,
              cid: _ctx.bookmarkSt.cid,
              isContentDetailPageToolbar: true
            }, null, 8, ["pid", "bid", "cid"]))
          : _createCommentVNode("", true),
        (!_ctx.isKn && !_ctx.isRekion)
          ? (_openBlock(), _createBlock(_component_DssIcon, {
              key: 1,
              icon: "separater",
              class: "has-text-thin"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('label.frameNumber')), 1),
        _createVNode(_component_AppInput, {
          class: "image-viewer-toolbar-frame-index",
          modelValue: _ctx.currentFrameIndex,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentFrameIndex) = $event)),
          min: 1,
          max: _ctx.currentBundleContents?.length,
          bindingDirection: _ctx.currentBindingDirection,
          type: "number",
          label: _ctx.$t('label.frameNumber')
        }, null, 8, ["modelValue", "max", "bindingDirection", "label"]),
        _createElementVNode("span", _hoisted_6, " /" + _toDisplayString(_ctx.currentBundleContents?.length), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppSelect, {
          id: "image-viewer-toolbar-binding-direction",
          modelValue: _ctx.currentBindingDirection,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentBindingDirection) = $event)),
          options: _ctx.directionList,
          "aria-label": _ctx.$t('label.frameFeedDirection')
        }, null, 8, ["modelValue", "options", "aria-label"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_AppSelect, {
          id: "image-viewer-toolbar-viewer-mode",
          modelValue: _ctx.state.viewMode,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.viewMode) = $event)),
          options: _ctx.viewModeListLocal,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('changeTwoInOneMode', _ctx.state.viewMode)))
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_InputSpinnerScale, {
          class: "image-viewer-toolbar-zoom-rate has-form-label",
          modelValue: _ctx.state.zoomRate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.zoomRate) = $event)),
          styled: "is-none",
          min: 5,
          max: 400,
          step: 5,
          label: _ctx.$t('label.magnification'),
          "label-left": _ctx.$t('label.shrink'),
          "label-right": _ctx.$t('label.expansion')
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["modelValue", "label", "label-left", "label-right"]),
        (_ctx.fullscreenEnabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_DssIcon, {
                icon: "separater",
                class: "has-text-thin"
              }),
              _createVNode(_component_ButtonIcon, {
                onClick: _ctx.toggleFullScreen,
                onKeydown: _withKeys(_withModifiers(_ctx.toggleFullScreen, ["prevent"]), ["space","enter"]),
                icon: _ctx.fullScreenIcon,
                styled: "is-none",
                id: "fullscreen-button",
                "aria-label": _ctx.fullScreenAriaLabel,
                class: "has-form-label"
              }, null, 8, ["onClick", "onKeydown", "icon", "aria-label"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (!_ctx.showLoadingIcon)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            ((_ctx.isBindingDirectionLtr && _ctx.currentContentIndex !== 0) || (!_ctx.isBindingDirectionLtr && _ctx.currentContentIndex < _ctx.contents.length - 1))
              ? (_openBlock(), _createBlock(_component_ButtonIcon, {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isBindingDirectionLtr ? _ctx.prevFrameIndex() : _ctx.nextFrameIndex())),
                  onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.isBindingDirectionLtr ? _ctx.prevFrameIndex() : _ctx.nextFrameIndex()), ["prevent"]), ["space","enter"])),
                  icon: "arrow-left",
                  styled: "is-none",
                  class: "image-viewer-toolbar-floating-decrement has-text-modest",
                  "aria-label": _ctx.$t('label.previousFrame')
                }, null, 8, ["aria-label"]))
              : _createCommentVNode("", true),
            ((_ctx.isBindingDirectionLtr && _ctx.currentContentIndex < _ctx.contents.length - 1) || (!_ctx.isBindingDirectionLtr && _ctx.currentContentIndex !== 0))
              ? (_openBlock(), _createBlock(_component_ButtonIcon, {
                  key: 1,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isBindingDirectionLtr? _ctx.nextFrameIndex() : _ctx.prevFrameIndex())),
                  onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.isBindingDirectionLtr? _ctx.nextFrameIndex() : _ctx.prevFrameIndex()), ["prevent"]), ["space","enter"])),
                  icon: "arrow-right",
                  styled: "is-none",
                  class: "image-viewer-toolbar-floating-increment has-text-modest",
                  "aria-label": _ctx.$t('label.nextFrame')
                }, null, 8, ["aria-label"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}